import { Button, Col, Form, FormGroup, Row, Card } from "react-bootstrap";
import { getCustomerTicket, getCustomerTicketList, getCustomerTicketList_Local, addCustomerTicket, closeCustomerTicket } from "../../store/api/CustomerApi";
import { Link45deg, JournalX, DashCircle, CheckLg, X, Search, Check2Square } from "react-bootstrap-icons";
import BihamtaTable from "../../../Components/BihamtaTable";
import { useRef, useState, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { attachFile, setErrorDialog, downloadFile, ticketStatuses } from "../../../store/api/CommonFunctions";
import PopSetTicketPriority from "./PopSetTicketPriority";
import ModalCreateEditWorkItems from "../../../Projects/pages/ModalCreateEditWorkItems";

const CustomerTickets = (props) => {
    const { customerID } = props;
    const frmTicket = useRef();
    const inputFile = useRef();
    const history = useHistory();
    const filterData = useRef({});
    const dispatch = useDispatch();
    const [currTicket, setCurrTicket] = useState(null);
    const { register, errors, handleSubmit } = useForm();
    const [modalWorkItemData, setModalWorkItemData] = useState({ show: false });
    const showModalWorkItemData = (row) => {
        setModalWorkItemData({
            show: true,
            title: row.TicketDesc,
            entityType: "Ticket",
            entityId: row.ID
        })
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "وضعیت تیکت", colName: "PTicketStatus", showInMobile: true },
        {
            colTitle: "اولویت", colName: "PrioritySign", className: "rowBtn",
            //tooltip: (row) => row.PPriority, 
            styleCondition: (row) => ({ color: row.PriorityColor, fontWeight: "bold", width: "1px", fontSize: "16px" })
        },
        { colTitle: "تاریخ تیکت", colName: "PTicketDate", showInMobile: true },
        { colTitle: "موضوع تیکت", colName: "TicketSubject", showInMobile: true },
        { colTitle: "شرح تیکت", colName: "TicketDesc", showInMobile: false, colType: "string", maxTextLength: 185 },
        { colTitle: "شناسه پیگیری", colName: "ID", showInMobile: false }
    ]
    const tableRowButtons = [{
        title: "نمایش جزئیات", type: "show", className: "group-Btn-smalll btn-primary",
        onclick: (item) => showTicket(item)
    },
    {
        title: "تبدیل به وظیفه",
        type: "common",
        tooltip: "تبدیل به وظیفه",
        icon: <Check2Square className="rowBtn" color="green" />,
        onclick: showModalWorkItemData
    }];
    function addTicket(data) {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت تیکت");
                return;
            }
            else if (res.SMSError) {
                setErrorDialog(dispatch, res.SMSError, "ثبت تیکت");
            }
            const id = res.ResponseID ? res.ResponseID : res.ID;
            dispatch(attachFile(inputFile.current, id, "CustomerTicket", () => frmTicket.current.reset()));
            //For When Ticket Is New
            if (res.ID && res.TotalCount) {
                dispatch(getCustomerTicketList_Local({ ...res }));
                setCurrTicket({ ID: res.ID, ...data });
            }
            //
            else if (res.Data) {
                setCurrTicket({ ...res.Data });
            }
        }
        addCustomerTicket(data, onSuccess);
    }
    function cancelTicket() {
        setCurrTicket(null);
    }
    function showTicket(ticket) {
        getCustomerTicket(ticket.ID, (res) => { setCurrTicket(res.Data) });
    }
    function closeTicket() {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "بستن تیکت");
                return;
            }
            setCurrTicket(prev => ({ ...prev, TicketStatus: ticketStatuses.closed }));
        }
        closeCustomerTicket(currTicket.ID, onSuccess)
    }

    function search(filters) {
        filters.CustomerID = customerID;
        filterData.current = { ...filters, Skip: 0 }
        dispatch(getCustomerTicketList(filters));
    }
    function handleSetPriority(data) {
        setCurrTicket(null);
        dispatch(getCustomerTicketList(filterData.current));
    }
    return (
        <Row style={{ position: "relative" }}>
            <ModalCreateEditWorkItems modalData={modalWorkItemData} setModalData={setModalWorkItemData} />
            {currTicket &&
                <div className="rowBorder" style={{ padding: "10px" }}>
                    {Number(currTicket.ID) > 0 &&

                        <div style={{ position: "relative" }}>
                            {Number(currTicket.TicketStatus) === ticketStatuses.closed && <label style={{ padding: "5px", color: "red", border: "2px solid red", borderRadius: "2px", transform: "rotate(-20deg)", boxShadow: "0 0 3px", textShadow: "0px 0px 2px red", position: "absolute", left: "-25px", top: "-20px" }}>بسته شده</label>}
                            <Row style={{ margin: 0 }} className="gap-1">
                                <Col md={2} style={{ background: "#941262", padding: "5px", color: "white", borderRadius: "2px" }}>تاریخ ثبت: <span style={{ fontSize: "11px" }}>{currTicket.TicketHour}</span>-{currTicket.PTicketDate}</Col>
                                <Col md={1} style={{ background: "#3560b1", padding: "5px", color: "white", borderRadius: "2px" }}>شناسه پیگیری: {currTicket.ID}</Col>
                                <Col md={1} style={{ background: currTicket.PriorityColor, padding: "5px", color: "white", borderRadius: "2px" }}>اولویت: {currTicket.PPriority}</Col>
                                {Number(currTicket.AttachmentID) > 0 && <Col md={1} style={{ padding: 0 }}><Link45deg size={25} color="#c32baa" className="hoverIcon" onClick={() => downloadFile(currTicket.AttachmentID, "CustomerTicket")} /> </Col>}

                            </Row>
                            <div className="mt-2 col-md-4">
                                <label>موضوع: </label>
                                <Form.Control value={currTicket.TicketSubject} disabled={true} style={{ fontSize: "13px", fontWeight: "bold" }} />
                            </div>
                            <div className="mt-2">
                                <label>شــرح: </label>
                                <Form.Control as="textarea" rows={2} value={currTicket.TicketDesc} disabled={true} style={{ fontSize: "13px" }} />
                            </div>
                            {Number(currTicket.TicketStatus) !== ticketStatuses.closed &&
                                <div className="mt-2">
                                    <Button className="group-Btn-large" onClick={closeTicket}><JournalX size={16} />&nbsp; بستن تیکت</Button>
                                    <PopSetTicketPriority id={currTicket.ID} defaultPriority={currTicket.Priority} onSet={handleSetPriority} />
                                </div>
                            }
                        </div>

                    }
                    {
                        currTicket.Responses && Array.isArray(currTicket.Responses) && currTicket.Responses.length > 0 &&
                        <div className="rowBorder mt-4" style={{ borderColor: "#ff00003b", boxShadow: "0 0 1px" }}>
                            <div className="rowTitle">پاسخ ها</div>
                            <div style={{ maxHeight: "290px", overflow: "auto" }}>
                                {currTicket.Responses.map((res, i) =>
                                    <Card style={{ margin: "12px", background: "transparent" }} key={i}>
                                        <Card.Body>
                                            <div style={{ position: "absolute", padding: "5px", background: "#c470e5", top: "-5px", left: "-5px", transform: "rotate(-20deg)", fontSize: "11px", borderRadius: "2px", boxShadow: "0px 0px 2px" }}>
                                                {res.PTicketDate}
                                            </div>
                                            <div style={{ position: "absolute", padding: "1px 5px 1px 5px", background: "#7077e5", top: "16px", left: "6px", transform: "rotate(-10deg)", fontSize: "11px", borderRadius: "2px", color: "white", boxShadow: "0px 0px 2px black" }}>
                                                {res.TicketHour}
                                            </div>
                                            {res.AttachmentID &&
                                                <div style={{ position: "absolute", padding: "1px 5px 1px 5px", top: "5px", right: "6px", color: "#ff2300" }} className="hoverIcon">
                                                    <Link45deg size={21} onClick={() => downloadFile(res.AttachmentID, "CustomerTicket")} />
                                                </div>
                                            }
                                            <Form.Control as="textarea" rows={window.innerWidth > 414 ? 2 : 3} value={res.TicketDesc} readOnly style={{ backgroundColor: res.ResponderName ? "#ede9ef" : "#dadef6", border: "none", fontSize: "13px" }} />
                                            <div style={{ position: "absolute", padding: "1px 5px 1px 5px", background: "#595a95", bottom: "22px", left: "22px", fontSize: "11px", borderRadius: "2px", color: "white", boxShadow: "0px 0px 2px black" }}>
                                                {res.ResponderName ? res.ResponderName : res.CustomerName}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                )
                                }
                            </div>
                        </div>
                    }
                    {Number(currTicket.ID) > 0 && Number(currTicket.TicketStatus) !== ticketStatuses.closed &&
                        <form ref={frmTicket} onSubmit={handleSubmit(addTicket)} readOnly>
                            <input type="hidden" name="ParentID" ref={register({ required: true })} value={currTicket.ID} />
                            <FormGroup>
                                <label>شــرح: </label>
                                <Form.Control as="textarea" rows={2} name="TicketDesc" ref={register({ required: true })} />
                                {errors?.TicketDesc && <small className="errors">شرح تیکت الزامی است</small>}
                            </FormGroup>
                            <Fragment>
                                <Form.Group>
                                    <label>پیوست: </label>
                                    <input type="file" className="form-control" ref={inputFile} />
                                </Form.Group>
                                <div className="mt-2">
                                    <Button className="group-Btn" variant="info" type="submit"><CheckLg size={15} />&nbsp;ثبت پاسخ</Button>
                                    <Button className="group-Btn" variant="danger" onClick={cancelTicket}><DashCircle size={15} />&nbsp;انصراف</Button>
                                </div>
                            </Fragment>
                        </form>
                    }
                    {Number(currTicket.TicketStatus) === ticketStatuses.closed &&
                        <Button className="group-Btn mt-2" variant="danger" onClick={cancelTicket}><X size={20} />&nbsp;بستن</Button>
                    }
                </div>

            }
            {!currTicket &&
                <form readOnly onSubmit={handleSubmit(search)}>
                    <Row className="rowBorder">

                        <FormGroup className="col-md-2">
                            <label>شناسه پیگیری: </label>
                            <Form.Control name="ID" ref={register({})} />
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label>وضعیت تیکت: </label>
                            <select className="form-control" defaultValue="" name="TicketStatus" ref={register({})}>
                                <option value="">انتخاب کنید</option>
                                <option value={ticketStatuses.registered}>جدید</option>
                                <option value={ticketStatuses.underChecking}>دردست بررسی</option>
                                <option value={ticketStatuses.checkedOut}>بررسی شده</option>
                                <option value={ticketStatuses.closed}>بسته شده</option>
                            </select>
                        </FormGroup>
                        <FormGroup className="col-md-2">
                            <label>موضوع تیکت: </label>
                            <Form.Control name="TicketSubject" ref={register({})} />
                        </FormGroup>
                        <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "1px" }}>
                            <Button variant="secondary" className="group-Btn-large" type="submit"><Search size={16} />&nbsp; جستجوی تیکت</Button>
                        </Col>
                    </Row>
                </form>

            }
            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} maxHeight={350}
                searchMethod={(data) => dispatch(getCustomerTicketList(data))} reducerName="customerDataReducer" objectName="customerTicketList" hasPaging={true} rowClick={showTicket} />
        </Row>
    )
}
export default CustomerTickets;